export type CookieConfig = {
  cookieName: string;
  cookieExpires?: number;
  cookiePath?: string;
  cookieDomain?: string;
  i18n: Record<string, Record<string, string | JSX.Element>>;
  services: Record<string, CookieService>;
  categories: Record<string, CookieCategory>;
};

export type CookieService = {
  title: string;
  description: Record<string, string>;
  cookies: (string | RegExp)[];
  category: string;
};

export type CookieCategory = {
  label: CookieTranslatedValue;
};

export type CookieTranslatedValue = {
  [key: string]: string;
};

export const cookieConfig: CookieConfig = {
  cookieName: 'cookie-consent',
  i18n: {
    en: {
      noticeTitle: 'This website uses cookies',
      noticeDescriptionPrefix: 'Hi! Could we please enable some additional services for ',
      noticeDescriptionSuffix: '? You can always change or withdraw your consent later.',
      noticeButtonAccept: 'Accept',
      noticeButtonDecline: 'Decline',
      noticeButtonSettings: 'Settings...',

      modalTitle: 'Services we would like to use',
      modalDescriptionPrefix:
        'In this section, you can evaluate and customize the services we wish to use on this website. You have the say! Enable or disable the services as you see fit. To learn more, please read our ',
      modalDescriptionLinkLabel: 'privacy policy',
      modalDescriptionSuffix: '.',
      modalButtonAccept: 'Allow all',
      modalButtonDecline: 'Decline all',
      modalButtonSave: 'Accept selected',
    },
    de: {
      noticeTitle: 'Diese Website verwendet Cookies',
      noticeDescriptionPrefix: 'Hallo! Könnten wir bitte einige zusätzliche Dienste für ',
      noticeDescriptionSuffix: ' aktivieren? Sie können Ihre Zustimmung später jederzeit ändern oder zurückziehen.',
      noticeButtonAccept: 'Akzeptieren',
      noticeButtonDecline: 'Ablehnen',
      noticeButtonSettings: 'Einstellungen...',

      modalTitle: 'Dienste, die wir nutzen möchten',
      modalDescriptionPrefix:
        'Hier können Sie die Dienste, die wir auf dieser Website nutzen möchten, bewerten und anpassen. Sie haben das Sagen! Aktivieren oder deaktivieren Sie die Dienste, wie Sie es für richtig halten. Um mehr zu erfahren, lesen Sie bitte unsere ',
      modalDescriptionLinkLabel: 'Datenschutzerklärung',
      modalDescriptionSuffix: '.',
      modalButtonAccept: 'Alle akzeptieren',
      modalButtonDecline: 'Alle ablehnen',
      modalButtonSave: 'Auswahl akzeptieren',
    },
  },
  categories: {
    analytics: {
      label: {
        en: 'Visitor statistics',
        de: 'Besucherstatistiken',
      },
    },
    functionality: {
      label: {
        en: 'Functionality',
        de: 'Funktionalität',
      },
    },
  },
  services: {
    matomo: {
      title: 'Matomo',
      description: {
        en: 'Analyze visitor traffic and popularity of individual page areas.',
        de: 'Analysieren des Besucheraufkommens und der Beliebtheit einzelner Seitenbereiche.',
      },
      cookies: [/^_pk_.*$/],
      category: 'analytics',
    },
    youtube: {
      title: 'YouTube',
      description: {
        en: 'Display of videos via the platform YouTube.',
        de: 'Anzeige von Videos über die Plattform YouTube.',
      },
      cookies: ['CONSENT', 'VISITOR_INFO1_LIVE', 'YSC', 'PREF'],
      category: 'functionality',
    },
  },
};
